import "./sticky-email-cta.scss";
import { useEffect, useState } from "react";
import cn from "clsx";

import {
  NewsletterSignup,
  NewsletterSignupProps,
} from "design-system/components/primitives/newsletter-signup/newsletter-signup";

export interface StickyEmailCtaProps {
  heading?: string;
  subheading?: string;
  showNewsletterSignup?: boolean;
  newsletterSignup?: NewsletterSignupProps;
  preventAnimateIn?: boolean;
}

export function StickyEmailCta({
  showNewsletterSignup = true,
  preventAnimateIn = false,
  newsletterSignup,
}: StickyEmailCtaProps) {
  const [sticky, setSticky] = useState(preventAnimateIn);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    setSticky(scrollTop >= 1000);
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const sidebarClass = cn(
    "hbs-article-email-cta",
    sticky && "hbs-article-email-cta--sticky",
  );

  return (
    <div className={sidebarClass}>
      <div className="hbs-article-email-cta__content">
        {showNewsletterSignup && (
          <NewsletterSignup
            title={newsletterSignup?.title}
            subtitle={newsletterSignup?.subtitle}
          />
        )}
        {/* Usable space for Wunderkind block */}
      </div>
    </div>
  );
}
